import axiosInstance from "./axiosInstance";

export const AuthserverService = {
  getAllAuthservers: async (organizationId: string) => {
    const response = await axiosInstance.get(
      `/api/v1/organizations/${organizationId}/authservers`
    );
    return response.data;
  },

  createAuthserver: async (organizationId: string, environmentId: string, data: any) => {
    const response = await axiosInstance.post(
      `/api/v1/organizations/${organizationId}/environments/${environmentId}/authservers`,
      data
    );
    return response.data;
  },

  updateAuthserver: async (organizationId: string, environmentId: string, authserverId: string, data: any) => {
    const response = await axiosInstance.put(
      `/api/v1/organizations/${organizationId}/environments/${environmentId}/authservers/${authserverId}`,
      data
    );
    return response.data;
  },

  deleteAuthserver: async (organizationId: string, environmentId: string, authserverId: string) => {
    const response = await axiosInstance.delete(
      `/api/v1/organizations/${organizationId}/environments/${environmentId}/authservers/${authserverId}`
    );
    return response.data;
  }
};
